export default __webpack_public_path__ + "static/media/back-arrow.5604bd35.svg";